import { render, staticRenderFns } from "./InstagramAnalyticsPublic.vue?vue&type=template&id=18e460a4&scoped=true"
import script from "./InstagramAnalyticsPublic.vue?vue&type=script&lang=ts"
export * from "./InstagramAnalyticsPublic.vue?vue&type=script&lang=ts"
import style0 from "./InstagramAnalyticsPublic.vue?vue&type=style&index=0&id=18e460a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e460a4",
  null
  
)

export default component.exports